import { jsxs, jsx } from "react/jsx-runtime";
const SomethingWentWrongIcon = () => /* @__PURE__ */ jsxs("svg", { width: "199", height: "200", viewBox: "0 0 199 200", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_305_108824)", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M197.906 113.11L186.09 107.326C186.569 101.761 185.906 96.3387 184.291 91.2963L194.517 83.0503L184.844 67.8668L173.002 73.5826C169.414 70.2551 165.221 67.5369 160.56 65.6312L160.795 52.5454L142.906 50.1699L139.697 62.8447C134.195 63.5223 128.977 65.2935 124.298 67.9545L114.106 59.7229L101.214 72.3085L109.25 82.6179C106.517 87.1637 104.627 92.3096 103.814 97.8716L91.0365 100.806L93.0514 118.678L106.153 118.714C108.133 123.807 111.11 128.443 114.87 132.366L109.32 144.215L124.693 153.636L132.804 143.349C134.907 143.981 137.086 144.46 139.333 144.759C142.094 145.125 144.826 145.207 147.502 145.036L153.048 156.901L170.172 151.221L167.471 138.383C172.005 135.426 175.946 131.599 179.033 127.098L191.855 130.053L197.906 113.11Z",
        fill: "#B3B0AD"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M144.806 124.184C156.088 124.184 165.233 115.071 165.233 103.828C165.233 92.5861 156.088 83.4724 144.806 83.4724C133.525 83.4724 124.38 92.5861 124.38 103.828C124.38 115.071 133.525 124.184 144.806 124.184Z",
        fill: "#8A8886"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M87.0879 159.938C87.378 157.768 87.438 155.622 87.3051 153.517L98.5744 148.011L91.146 130.059L79.2347 134.078C76.4273 130.872 72.9986 128.206 69.0903 126.275L69.9402 113.791L50.6257 111.226L48.1686 123.482C43.8796 124.321 39.8609 126 36.3011 128.363L25.8851 121.393L13.999 136.78L23.3959 145.006C22.7104 147.01 22.2026 149.105 21.9114 151.283C21.6201 153.461 21.5596 155.616 21.6947 157.728L10.4644 163.215L17.8928 181.167L29.7768 177.158C32.5912 180.368 36.0288 183.036 39.9475 184.966L39.0985 197.435L58.4129 200L60.8731 187.729C65.1525 186.886 69.1621 185.208 72.7139 182.847L83.1537 189.833L95.0397 174.446L85.6104 166.191C86.2916 164.195 86.7978 162.108 87.0879 159.938Z",
        fill: "#8A8886"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M54.4998 172.202C63.6952 172.202 71.1495 164.774 71.1495 155.61C71.1495 146.447 63.6952 139.018 54.4998 139.018C45.3044 139.018 37.8501 146.447 37.8501 155.61C37.8501 164.774 45.3044 172.202 54.4998 172.202Z",
        fill: "#605E5C"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M75.9292 31.6566C72.2111 10.7979 52.2291 -3.10749 31.2983 0.597711C10.3674 4.30292 -3.58629 24.2158 0.131761 45.0745C3.84981 65.9332 23.8317 79.8385 44.7625 76.1333C46.9768 75.7413 49.1074 75.1579 51.1529 74.4211L64.062 85.3223C65.4902 86.5283 67.6611 85.3608 67.4338 83.5091L65.2226 65.5062C73.8129 56.9436 78.2155 44.4821 75.9292 31.6566Z",
        fill: "#ED6C47"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M41.5533 62.1793C44.254 62.1793 46.4433 59.9975 46.4433 57.3062C46.4433 54.6148 44.254 52.433 41.5533 52.433C38.8526 52.433 36.6632 54.6148 36.6632 57.3062C36.6632 59.9975 38.8526 62.1793 41.5533 62.1793Z",
        fill: "#E2E2F6"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M40.0036 48.6175C37.7852 49.0101 35.668 47.5366 35.2741 45.3258L30.5436 18.7801C30.1497 16.5694 31.6284 14.4595 33.8468 14.067C36.0651 13.6744 38.1824 15.1479 38.5763 17.3587L43.3067 43.9044C43.7006 46.1151 42.222 48.2249 40.0036 48.6175Z",
        fill: "#E2E2F6"
      }
    )
  ] }),
  /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_305_108824", children: /* @__PURE__ */ jsx("rect", { width: "198.374", height: "200", fill: "white" }) }) })
] });
export {
  SomethingWentWrongIcon
};
//# sourceMappingURL=SomethingWentWrongIcon.js.map
